import React from "react";
import { CtaButton } from "./CtaButton";
import { Countdown } from "./Countdown";
import { images } from "../data/content";
export function FinalCta() {
  return <section className="bg-night px-4 py-16 sm:px-6 sm:py-20" data-id="element-117" data-mp="vhiv81mffeaf">
      <div className="mx-auto max-w-3xl text-center" data-id="element-118" data-mp="19giip5y7dn50">
        <h2 className="font-display text-[30px] font-extrabold leading-[1.1] text-white sm:text-5xl" data-id="element-119" data-mp="15dltuxi2kusm">
          Ready to Bring More Structure to Your CAN Bus Diagnostics?
        </h2>
        <p className="mt-5 text-[17px] leading-relaxed text-white/80 sm:text-lg" data-id="element-120" data-mp="1ee1wy5uwhzwy">
          You don't need another collection of disconnected notes. You need a way to organize the information,
          document your findings, and determine what to investigate next.
        </p>
        <img src={images.mockup} alt="CAN Bus Diagnostic Blueprint bundle" className="mx-auto mt-8 w-full max-w-xl" data-id="element-121" data-mp="1o5y6qe6cneh0" />
        <p className="mt-4 font-display text-xl font-bold text-white" data-id="element-122" data-mp="1x4jmk1kfsfe3">
          Start building a more consistent diagnostic workflow today.
        </p>
        <p className="mt-4 font-display text-5xl font-black text-gold" data-id="element-123" data-mp="n6w5wvtqbkam">JUST $27 USD</p>
        <div className="mt-8" data-id="element-124" data-mp="s5qopxrp58uq">
          <CtaButton label="Yes! I want the CAN Bus Diagnostic Blueprint" data-id="element-125" data-mp="s4xpdhv2hlmm" />
        </div>
        <p className="mt-4 text-sm text-white/70" data-id="element-126" data-mp="x27e0vamtt9e">
          Instant Digital Access · One-Time Payment · Lifetime Access · 7-Day Money-Back Guarantee
        </p>
        <Countdown dark data-id="element-127" data-mp="16501soklvmuh" />
      </div>
    </section>;
}